import {
    REQUEST_EXPERTS,
    RESPONSE_EXPERTS,
    FAILURE_EXPERTS,
    GLOBAL_KEYWORD_CHANGE,
    MULTI_SEARCH_CHANGE,
    REMOVE_SUGGESTION,
    MULTI_SEARCH_KEYWORDS_CHANGE,
    EXPERT_MULTI_KEYWORD_CHANGE,
    INCREMENT, 
    SET_ZERO
} from '../../actions/types';
import { EXPERTS_SEARCH_API, EXPERT_MULTI_SEARCH_API } from '../../constants/_api';
import query from './query';
import asyncActionErrorHandler from '../../utils/asyncActionErrorHandler';

const dispatchGlobalKeywordChange = (dispatch, payload) => dispatch({
    type: GLOBAL_KEYWORD_CHANGE,
    payload
});

const dispatchRequest = (dispatch, payload) => dispatch({
    type: REQUEST_EXPERTS,
    payload
});

const dispatchResponse = (dispatch, payload) => dispatch({
    type: RESPONSE_EXPERTS,
    payload
});

const dispatchFailure = (dispatch, payload) => dispatch({
    type: FAILURE_EXPERTS,
    payload
});

const dispatchMultiSearchChange = (dispatch, payload) => dispatch({
    type: MULTI_SEARCH_CHANGE,
    payload
})



const dispathcMultiSearchKeyword = (dispatch, payload) => dispatch({
    type: MULTI_SEARCH_KEYWORDS_CHANGE,
    payload
})



export const getExperts = (keyword, token) => asyncActionErrorHandler(async (dispatch) => {
    
    if (!keyword) {
        return
    }

     //REMOVE SUGGESTIONS
     dispatch({
        type: REMOVE_SUGGESTION
    });

    //DISPATCH GLOBAL KEYWORD CHANGE
    dispatchGlobalKeywordChange(dispatch, { keyword });

    dispatchRequest(dispatch, { keyword });

     //DISPATCH MULTI KEYWORDS CHANGE
     dispathcMultiSearchKeyword(dispatch, {
        keywords: [keyword]
     });

     //REMOVE TEMPORARY MULTISEARCH KEYWORDS LIST
    //  dispatch({
    //     type: EXPERT_MULTI_KEYWORD_CHANGE,
    //     payload: {}
    //   })


    let requestTime= Date.now()
    

    let url = `${EXPERTS_SEARCH_API}?q=${keyword}`;
    let result = await query(url, token);
    result = await result.json();
    result.keyword = keyword;
    result.body.statusCode = result.statusCode;
    
    

    if (result.message === 'SUCCESS') {

        if(result.body.results.length>0){
            dispatch({
                type: SET_ZERO
            });
    
        }else if(result.body.results.length==0){
            dispatch({
                type: INCREMENT
            });
        }
        
        if(result.body.results.length>0){
            let ResultFound= 'Yes';
            let responseTime = Date.now()
        let TimeTaken=(responseTime - requestTime)/1000
        let RequestTime= new Date().toTimeString()
        let ResponseTime = new Date().toTimeString()
        TimeTaken = TimeTaken + "seconds"
        result.body={
            ...result.body,
            ResultFound,
            keyword,
            RequestTime,
            ResponseTime,
            TimeTaken
        }

        }else if(result.body.results.length==0){
            let responseTime = Date.now()
        let TimeTaken=(responseTime - requestTime)/1000
        let RequestTime= new Date().toTimeString()
        let ResponseTime = new Date().toTimeString()
        let ResultFound= 'No';
        TimeTaken = TimeTaken + "seconds"
        result.body={
            ...result.body,
            ResultFound,
            keyword,
            RequestTime,
            ResponseTime,
            TimeTaken
        }

            
        }
        
        dispatchResponse(dispatch, result.body);

         //REMOVE SUGGESTIONS
         dispatch({
            type: REMOVE_SUGGESTION
        });

    } else if(result.message === 'FAILED'){
        
        let responseTime = Date.now()
        let TimeTaken=(responseTime - requestTime)/1000
        let RequestTime= new Date().toTimeString()
        let ResponseTime = new Date().toTimeString()
        let ResultFound = 'No';
        TimeTaken = TimeTaken + "seconds"
        result.body={
            ...result.body,
            ResultFound,
            keyword,
            RequestTime,
            ResponseTime,
            TimeTaken
        }
        
        
        dispatchFailure(dispatch, result.body);

         //REMOVE SUGGESTIONS
         dispatch({
            type: REMOVE_SUGGESTION
        });
    }
    // console.log(result);


     //REMOVE SUGGESTIONS
     dispatch({
        type: REMOVE_SUGGESTION
    });

}, dispatchFailure);